var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetSuccessful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2305,
    cy: 38,
    r: 38,
    fill: "#F3F4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0863 24.101C54.4979 23.5115 53.5431 23.5105 52.9547 24.0985L36.8693 40.1361L30.3441 33.0492C29.7803 32.4372 28.827 32.3975 28.214 32.9612C27.6014 33.525 27.5622 34.4788 28.126 35.0914L35.714 43.3321C35.9919 43.6341 36.3808 43.8095 36.7908 43.818C36.8019 43.8185 36.8125 43.8185 36.823 43.8185C37.2215 43.8185 37.6049 43.6602 37.8873 43.3788L55.0833 26.2331C55.6733 25.6452 55.6743 24.6904 55.0863 24.101Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7229 36.4924C55.8902 36.4924 55.2154 37.1673 55.2154 38C55.2154 47.3659 47.5963 54.9849 38.2305 54.9849C28.8652 54.9849 21.2455 47.3659 21.2455 38C21.2455 28.6347 28.8652 21.0151 38.2305 21.0151C39.0631 21.0151 39.738 20.3402 39.738 19.5076C39.738 18.6748 39.0631 18 38.2305 18C27.2023 18 18.2305 26.9719 18.2305 38C18.2305 49.0277 27.2023 58 38.2305 58C49.2581 58 58.2305 49.0277 58.2305 38C58.2305 37.1673 57.5556 36.4924 56.7229 36.4924Z",
    fill: "#2D2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSuccessful);
export default __webpack_public_path__ + "static/media/reset_successful.1a3500b389e83fa1fafe13d23a03e25d.svg";
export { ForwardRef as ReactComponent };